import { render, staticRenderFns } from "./PageIndexGoodsManangement.vue?vue&type=template&id=2a33aab2&scoped=true"
import script from "./PageIndexGoodsManangement.vue?vue&type=script&lang=js"
export * from "./PageIndexGoodsManangement.vue?vue&type=script&lang=js"
import style0 from "./PageIndexGoodsManangement.vue?vue&type=style&index=0&id=2a33aab2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a33aab2",
  null
  
)

export default component.exports